/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import chevronDownIcon from 'client-ribbons-design-system/assets/icons-16-chevron-down.svg';

const { fonts, spacing } = theme;

const primaryRegularFont = css`
  font-family: ${fonts.PRIMARY_REGULAR.family}, Helvetica, Arial, sans-serif;
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
`;

export const select = css`
  ${primaryRegularFont}
  ${theme.responsiveText.BODY.MD};

  appearance: none;
  background-color: var(--neutral-white-base);
  background-image: url(${chevronDownIcon});
  background-position: calc(100% - ${pxToRem(16)}) 50%;
  background-repeat: no-repeat;
  border: solid ${pxToRem(1)} var(--neutral-black-70);
  border-radius: ${pxToRem(10)};
  color: var(--neutral-black-base);
  display: block;
  padding: ${pxToRem(9)} ${spacing.xxxl}px ${pxToRem(9)} ${spacing.md}px;
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;
  width: 100%;

  [data-has-error='true'] & {
    background-color: var(--tertiary-red-50);
    border-color: var(--tertiary-red-50);
  }

  [data-is-valid='true'] & {
    background-color: var(--tertiary-green-50);
    border-color: var(--functional-green-base);
  }

  [data-has-error='false'][data-is-valid='false'] &:hover {
    border-color: var(--neutral-black-70);
  }

  [data-has-error='false'][data-is-valid='false'] &:focus {
    border-color: var(--brand-purple-base);
  }
`;
